import { render, staticRenderFns } from "./CPrgTreeTable.vue?vue&type=template&id=4aec01b8&scoped=true&"
import script from "./CPrgTreeTable.vue?vue&type=script&lang=ts&"
export * from "./CPrgTreeTable.vue?vue&type=script&lang=ts&"
import style0 from "./CPrgTreeTable.vue?vue&type=style&index=0&id=4aec01b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec01b8",
  null
  
)

export default component.exports